import React, { Fragment, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";

// Redux
import { Provider } from "react-redux";
import store from "./store";

// Components
// Create Private Route for Dashboard and display Navbar
import Navbar from "./components/layout/Navbar";
import Register from "./components/auth/Register";
import Login from "./components/auth/Login";
import AllListings from "./components/allListings/AllListing";
import MyListings from "./components/MyListings";
import AddListingForm from "./components/AddListingForm";
import EditListingForm from "./components/EditListingForm";
import EditAddress from "./components/EditAddress";
import Dashboard from "./components/Dashboard";
import CheckOut from "./components/CheckOut";
import PrivateRoute from "./components/routing/PrivateRoute";
import setAuthToken from "./utils/setAuthToken";
import Cart from "./components/Cart";
import ListingCard from "./components/allListings/ListingCard";
import { setUserData } from "./actions/auth";

const App = () => {
  // useEffect(() => {
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   if (user) {
  //     setUserData(user);
  //   }
  //   // setUserData(user);
  //   console.log(setUserData);
  //   console.log("user function:", user);
  // }, []);

  return (
    <Provider store={store}>
      <Router>
        <Fragment>
          {/* {isAuthenticated ? <Navbar /> : null}; */}
          <Navbar />
          <section className='container'>
            <Switch>
              <Route exact path='/register' component={Register} />
              <Route exact path='/' component={Login} />
              <PrivateRoute exact path='/listing/:id' component={ListingCard} />
              <PrivateRoute
                exact
                path='/edit-address'
                component={EditAddress}
              />
              <PrivateRoute exact path='/my-listings' component={MyListings} />
              <PrivateRoute
                exact
                path='/add-listing'
                component={AddListingForm}
              />
              <PrivateRoute
                exact
                path='/all-listings'
                component={AllListings}
              />
              <PrivateRoute path='/edit-listing' component={EditListingForm} />
              <PrivateRoute exact path='/dashboard' component={Dashboard} />
              <PrivateRoute exact path='/cart' component={Cart} />
              <PrivateRoute exact path='/checkout' component={CheckOut} />
            </Switch>
          </section>
        </Fragment>
      </Router>
    </Provider>
  );
};

export default App;
